// @flow

import {
	BIRTH_CERTIFICATE_RF,
	OFFICER_ID,
	NAVY_PASSPORT,
	MILITARY_PASSPORT,
	DIPLOMATIC_PASSPORT,
	FOREIGN_PASSPORT,
	RESIDENCE_PERMIT,
	REFUGEE_ID,
	TEMPORARY_ID,
	PASSPORT_RF,
	TRAVEL_PASSPORT,
	BIRTH_CERTIFICATE_FOREIGN,
	SEAMAN_PASSPORT,
} from 'known-rest-identity-docs';

import {
	CERTIFICATE as CERTIFICATE_OF_STATE_REGISTRATION,
	CERTIFICATE_TAX_AUTORITY as CERTIFICATE_OF_REGISTRATION_INTO_TAX_AUTHORITY
} from 'known-juridical-identity-types';

export type IDocumentTypeChecksExtend = {
	// ФЛ
	isDocumentRfPassport: () => boolean,
	isDocumentSeamanPassport: () => boolean,
	isDocumentRfBirthCertificate: () => boolean,
	isDocumentMilitaryPassport: () => boolean,
	isDocumentOfficerID: () => boolean,
	isDocumentNavyPassport: () => boolean,
	isDocumentDiplomaticPassport: () => boolean,
	isDocumentForeignPassport: () => boolean,
	isDocumentResidencePermit: () => boolean,
	isDocumentRefugeeID: () => boolean,
	isDocumentTemporaryID: () => boolean,
	isDocumentTravelPassport: () => boolean,
	isDocumentBirthCertificateForeign: () => boolean,

	// ЮЛ
	isCertificateOfStateRegistration: () => boolean,
	isCertificateOfRegistrationIntoTaxAuthority: () => boolean,
};

const identityDocumentTypeChecksExtend = {
	anonymous: target => {
		// ФЛ
		target.isDocumentRfPassport = () =>
			target() === PASSPORT_RF;
		target.isDocumentSeamanPassport = () =>
			target() === SEAMAN_PASSPORT;
		target.isDocumentRfBirthCertificate = () =>
			target() === BIRTH_CERTIFICATE_RF;
		target.isDocumentMilitaryPassport = () =>
			target() === MILITARY_PASSPORT;
		target.isDocumentOfficerID = () =>
			target() === OFFICER_ID;
		target.isDocumentNavyPassport = () =>
			target() === NAVY_PASSPORT;
		target.isDocumentDiplomaticPassport = () =>
			target() === DIPLOMATIC_PASSPORT;
		target.isDocumentForeignPassport = () =>
			target() === FOREIGN_PASSPORT;
		target.isDocumentResidencePermit = () =>
			target() === RESIDENCE_PERMIT;
		target.isDocumentRefugeeID = () =>
			target() === REFUGEE_ID;
		target.isDocumentTemporaryID = () =>
			target() === TEMPORARY_ID;
		target.isDocumentTravelPassport = () =>
			target() === TRAVEL_PASSPORT;
		target.isDocumentBirthCertificateForeign = () =>
			target() === BIRTH_CERTIFICATE_FOREIGN;

		// ЮЛ
		target.isCertificateOfStateRegistration = () =>
			target() === CERTIFICATE_OF_STATE_REGISTRATION;
		target.isCertificateOfRegistrationIntoTaxAuthority = () =>
			target() === CERTIFICATE_OF_REGISTRATION_INTO_TAX_AUTHORITY;
	},
};

export { identityDocumentTypeChecksExtend };
